export default {
  settings: {
    title: 'Configuración',
    account_related: 'Información de la cuenta',
    user_related: 'Información de la usuario',
    add_user_title: 'Añadir usuario',
    edit_user_title: 'Editar usuario',
    label: {
      enabled: 'Permitido',
      not_set: 'No establecido',
    },
    company: {
      title: 'Información de la empresa',
      name: 'Nombre de empresa',
      english_name: 'English name',
      scale: 'Número de empleados',
      industry_type: 'Industria',
      plan: 'Plan',
      location: 'Dirección',
      allowed_ip: 'Direcciones IP permitidas',
      mfa: 'Autenticación de SMS.',
      sales_amount: 'Ingresos',
      country: 'País',
    },
    contract_plans: {
      buyer: 'Plan de compradores',
      supplier: 'Plan de proveedores',
    },
    user: {
      title: 'Lista de usuarios',
      name: 'Nombre',
      first_name: 'Nombre',
      last_name: 'Apellido',
      email: 'Correo electrónico',
      email_unverified: 'Antes del registro',
      password: 'Contraseña',
      password_protection: 'Oculto por motivos de seguridad.',
      phone_number: 'Número telefónico',
      role: {
        title: 'Permiso',
        admin: 'Admin',
        general: 'General',
      },
      locale: 'Seleccione idioma',
      action: 'Operación',
      total: 'Todos: {total} (Máx: {max})',
    },
    button: {
      create: 'Agregar usuario',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '@:common.btn.update',
      delete: '@:common.btn.delete',
      do_delete: '@:common.btn.delete',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【Aviso】',
    cautions_01: 'No puede cambiar su dirección de correo electrónico. Para restablecer su correo electrónico, cree un nuevo usuario.',
    cautions_02: 'Se requiere un número telefónico si se activa la autenticación por SMS.',
    cautions_03: 'Para restablecer su contraseña, introduzca el código de verificación que le hemos enviado a su dirección de correo electrónico registrada en la pantalla de restablecimiento de contraseña.',
    cautions_04: 'Al borrar un usuario no se eliminan los datos de respuesta ni el cuadro de mando.',
    messages: {
      user_update: 'Actualizar la información de usuario',
      user_delete: 'Eliminar usuario',
      confirm_delete: '¿Desea eliminar este usuario?',
      complete_create: 'Se ha añadido información de usuario.',
      complete_update: 'Se ha actualizado la información de usuario.',
      complete_delete: 'La eliminación de la información del usuario ha finalizado.',
      disabled_delete: 'Por lo menos uno de los usuarios debe ser una autoridad «Administradora».',
      disabled_delete_by_auth: 'Solo lo puede eliminar el administrador.',
      invalid_form: 'Datos incorrectos.',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: 'Al hacer clic en «AÑADIR» se enviará un correo electrónico de confirmación a la dirección de correo electrónico proporcionada. \nPosteriormente se enviará un correo electrónico con su identificación y su contraseña.',
      caution_two: 'Se requiere un número telefónico si se activa la autenticación por SMS.',
      caution_three: 'Se pueden agregar hasta 5 usuarios.',
      user_add_title: '@:settings.button.create',
      user_add_message_one: 'Hemos enviado un correo electrónico a la dirección proporcionada. ',
      user_add_message_two: 'Compruebe su correo electrónico y siga las instrucciones para iniciar sesión.',
    },
    tips: {
      role: 'La autoridad «Admin» puede agregar y eliminar usuarios, pero la autoridad «General» no.',
      locale: 'Puede seleccionar la configuración de idioma inicial después del inicio de sesión.',
    },
    // english_name_edit_modal_title: "",
    // english_name_input_label: "",
    // english_name_placeholder: "",
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: '¿Está seguro de que desea desconectarse e ir a la página de restablecimiento de contraseña? En la página de restablecimiento de contraseña, introduzca el código de verificación proporcionado que se le ha enviado a su dirección de correo electrónico proporcionada.',
      reset: 'Restablecer contraseña',
    },
  },
}
